function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M14.5 0.288675C14.8094 0.110043 15.1906 0.110042 15.5 0.288675L27.4904 7.21132C27.7998 7.38996 27.9904 7.72008 27.9904 8.07735V21.9226C27.9904 22.2799 27.7998 22.61 27.4904 22.7887L15.5 29.7113C15.1906 29.89 14.8094 29.89 14.5 29.7113L2.50962 22.7887C2.20022 22.61 2.00962 22.2799 2.00962 21.9226V8.07735C2.00962 7.72009 2.20022 7.38996 2.50962 7.21132L14.5 0.288675Z",
  fill: "#F4B746"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M14.5578 5.83817C14.7454 5.4826 15.2546 5.4826 15.4422 5.83817L17.9418 10.5757C18.0141 10.7128 18.146 10.8086 18.2987 10.835L23.5768 11.7483C23.9729 11.8168 24.1303 12.3011 23.8501 12.5894L20.1168 16.4306C20.0088 16.5418 19.9584 16.6968 19.9805 16.8502L20.743 22.1521C20.8002 22.5501 20.3882 22.8494 20.0274 22.672L15.2206 20.3085C15.0815 20.2401 14.9185 20.2401 14.7794 20.3085L9.97258 22.672C9.6118 22.8494 9.19982 22.5501 9.25704 22.1521L10.0195 16.8502C10.0416 16.6968 9.99121 16.5418 9.88316 16.4306L6.14993 12.5894C5.86973 12.3011 6.02709 11.8168 6.42324 11.7483L11.7013 10.835C11.854 10.8086 11.9859 10.7128 12.0582 10.5757L14.5578 5.83817Z",
  fill: "white"
});

function SvgStar(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStar);
export default __webpack_public_path__ + "static/media/star.b55ba0cdb1a0b7fc35bb6a6ff09d9b81.svg";
export { ForwardRef as ReactComponent };